import React, { useState } from 'react'
import Separator from '../../common/separator'
import { ProjectData } from '../../data/projects'
import ProjectCard from './project-card'
import './projects.css'

const Projects = () => {
    const FilterList = [
        {
            value: 'All',
            label: 'all'
        },
        {
            value: 'React',
            label: 'React js'
        },
        {
            value: 'Node',
            label: 'Node js'
        },
        {
            value: 'Python',
            label: 'Python'
        },
        {
            value: 'Angular',
            label: 'Angular'
        },
    ]

    const data = ProjectData
    const [activeFilter, setActiveFilter] = useState('all')
    return (
        <div className="projects">
            <Separator/>
            <label className="section-title">Projects</label>
            <div className="project-filter">
                <ul>
                {FilterList.map((filter, index) => {
                    return (
                        <li key={index} className={(activeFilter === filter.label) ? ('active'):('')} onClick={() =>{setActiveFilter(filter.label)}}>{filter.value}</li>
                    )
                })}
                </ul>
            </div>
            <div>
                {activeFilter !== 'all' ? (
                    data.filter(item => item.tags.includes(activeFilter)).map((project, index) =>{
                    return (
                        <ProjectCard key={index} index={index} project={project} />
                    )
                })
                ): (
                    
                        data.map((project, index) =>{
                    return (
                        <ProjectCard key={index} index={index} project={project} />
                    )
                })
                )
                }
            </div>
        </div>
    )
}

export default Projects
